import ApiService from "../../helpers/ApiHelper";

class ProfessionalService {

    static getProfessionals({ type = '', language, page = 1, pageSize = 20, q = '' }) {
        // Build query parameters
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('pageSize', pageSize);
        if (q) {
            params.append('q', q);
        }

        // Build URL - use /role/:role endpoint when type is provided, otherwise /users endpoint
        const url = type 
            ? `/api/v1/users/role/${type}?${params.toString()}`
            : `/api/v1/users/?${params.toString()}`;
        
        return ApiService.request(
            url,
            "get",
            {
                headers: {
                    'Accept-Language': language
                }
            }
        )
    }

    static removeProfessional(id) {
        return ApiService.request(
            `/api/v1/users/${id}`,
            "delete",
            null
        )
    }

    static editProfessional(professional) {
        professional.id = professional?.id ? professional?.id : professional?._id
        return ApiService.request(
            `/api/v1/users/${professional.id}`,
            "patch",
            professional,
        )
    }

    static updateTranslationsProfessional(professional) {
        console.log(professional)
        return ApiService.request(
            `/api/v1/translations/user/${professional.userId}`,
            "patch",
            professional,
        )
    }

    static approveProfessional(professional) {
        const professionalId = professional.id ? professional.id : professional._id
        return ApiService.request(
            `/api/v1/users/approve/${professionalId}`,
            "patch",
            { status: professional.status, approvedDate: professional.approvedDate },
        )
    }
}

export default ProfessionalService;
